import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null as string | null,
  errorMsg: false,
  profile: null as any,
  dashboard: null as any,
  analytics: null as any,
  referrals: [] as any[],
  commissions: [] as any[],
  marketingMaterials: [] as any[],
  generatedLink: null as any,
};

const affiliateSlice = createSlice({
  name: "Affiliate",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    apiError(state, action) {
      state.error = action.payload;
      state.errorMsg = true;
      state.loading = false;
    },
    setProfile(state, action) {
      state.profile = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    setDashboard(state, action) {
      state.dashboard = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    setAnalytics(state, action) {
      state.analytics = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    setReferrals(state, action) {
      state.referrals = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    setCommissions(state, action) {
      state.commissions = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    setMarketingMaterials(state, action) {
      state.marketingMaterials = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    setGeneratedLink(state, action) {
      state.generatedLink = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
  },
});

export const {
  setLoading,
  apiError,
  setProfile,
  setDashboard,
  setAnalytics,
  setReferrals,
  setCommissions,
  setMarketingMaterials,
  setGeneratedLink,
} = affiliateSlice.actions;

export default affiliateSlice.reducer;
